// extracted by mini-css-extract-plugin
module.exports = {"container":"CarComparison_container__Y7VOd","title":"CarComparison_title__F6VL7"};